$(document).ready(() =>
  $(".product-carousel").each(function() {
    let $container = $(this);
    let $owlContainer = $(this).find(".owl-carousel");

    let updateSlidesWidth = function() {
      let slideHeight = Math.max(300, Math.min($(window).height() * .75, ($(window).width() * .4)));

      let minSlideWidth = Math.min($(window).width(), 700);
      let maxSlideWidth = $(window).width() / 1.3;
      $owlContainer.height(slideHeight);

      let horizontalSlideProportions = 2 / 1;
      let verticalSlideProportions = 3 / 4;
      let horizontalSlideWidth = Math.max(minSlideWidth, Math.min(maxSlideWidth, slideHeight * horizontalSlideProportions));
      let verticalSlideWidth = Math.max(minSlideWidth, Math.min(maxSlideWidth, slideHeight * verticalSlideProportions));

      $owlContainer.find(".carousel-item").each(function(i, element) {

        let slideWidth = element.getAttribute("data-image-width") && element.getAttribute("data-image-height") ?
          +element.getAttribute("data-image-width") > +element.getAttribute("data-image-height") ?
            horizontalSlideWidth
          :
            verticalSlideWidth
        :
          horizontalSlideWidth;

        element.style.width = `${slideWidth}px`;
        return element.style.height = `${slideHeight}px`;
      });
      return $owlContainer.trigger("resize.owl.carousel");
    };

    $(window).resize(updateSlidesWidth);
    updateSlidesWidth();

    return $owlContainer.owlCarousel({
      center: true,
      // items: 1.3
      autoWidth: true,
      loop: true,
      margin: 5,
      nav: true,
      navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
      smartSpeed: 400,
      video: true,
      lazyLoad: true
    });
  })
);



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/product_carousel.js